import { render, staticRenderFns } from "./notifications-drawer.vue?vue&type=template&id=701fab55&"
import script from "./notifications-drawer.vue?vue&type=script&lang=js&"
export * from "./notifications-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports